class ReportContribution
{
	/** @type {PopupHelper} */
	_popupHelper = null;

	constructor()
	{
		let thisObj = this;
		this._popupHelper = new PopupHelper("#report-popup", {
			popupOKCallback: thisObj._submitRequest.bind(thisObj),
			resetFieldsCallback: thisObj._resetFields.bind(thisObj),
		});	
	}

	_resetFields()
	{
		const $reason = $(`${this._popupHelper.containerSelector} #report-reason`);
		$reason.val("");
	}

	open(endpoint)
	{
		this._popupHelper.open(endpoint);
	}

	_submitRequest(endpoint)
	{
		const popupHelper = this._popupHelper;
		const $reason = $(`${popupHelper.containerSelector} #report-reason`);
		const data = {
			reason: $reason.val(),
		};
		popupHelper.showLoading();
		dataAction.callClientPostEndpoint(
			endpoint,
			data,
			function (response) {
				popupHelper.close();
				showSuccessPopup(response, mvvm.reset);
			},
			popupHelper.defaultResponseErrorHandler.bind(popupHelper),
			popupHelper.hideLoading.bind(popupHelper)
		);
	}
}